import { combineReducers } from 'redux';

import utils from './../../../utils/utilities';

import {

    ADD_RSS_RESET_PAGE,
    ADD_RSS_CHANGE_FEED_DATA,
    ADD_RSS_FEED_NAME_VALIDATED,
    ADD_RSS_FEED_NAME_INVALIDATED,
    ADD_RSS_SET_CATEGORIES,
    ADD_RSS_CHANGE_THIRD_PARTIES_URL_PARAMS,
    ADD_RSS_SELECT_THIRD_PARTIES,
    ADD_RSS_COUNT_THIRD_PARTIES,
    ADD_RSS_FILTER_COUNT_THIRD_PARTIES,
    ADD_RSS_CLEAR_SELECTED_THIRD_PARTIES,
    ADD_RSS_SELECT_THIRD_PARTIES_SHOW_SPINNER,
    ADD_RSS_SELECT_THIRD_PARTIES_HIDE_SPINNER,
    ADD_RSS_DESELECT_THIRD_PARTY,
    ADD_RSS_SET_SELECTED_CATEGORIES,
    ADD_RSS_SET_SELECTED_THIRDPARTIES,
    ADD_RSS_SELECT_THIRD_PARTIES_OPTION,
    ADD_RSS_SELECT_CATEGORY,
    ADD_RSS_DESELECT_CATEGORY,
    ADD_RSS_SELECT_ALL_CATEGORIES,
    ADD_RSS_DESELECT_ALL_CATEGORIES,
    ADD_RSS_CHANGE_RISK_ANGLES,
    ADD_RSS_SAVE_ERROR,
    ADD_RSS_CLEAR_SAVE_ERRORS,
    ADD_RSS_TABLE_URL_CHANGE,
    ADD_RSS_SELECT_THIRD_PARTIES_SET,
    ADD_RSS_DESELECT_THIRD_PARTIES_SET

} from './BaseFeedEditingComponent.actions.js';

function thirdParties(state = null, action) {

    switch (action.type) {

        case ADD_RSS_CHANGE_THIRD_PARTIES_URL_PARAMS:
            return Object.assign(
                {}, state, {
                    urlParams: Object.assign({}, state.urlParams, action.payload)
                }
            );

        case ADD_RSS_SELECT_THIRD_PARTIES_OPTION:
            return Object.assign(
                {}, state, {
                    selectedCategories:     [],
                    selectedThirdParties:   [],
                    allCategoriesSelected:  false,
                    thirdPartySelectionBox: action.payload
                }
            );

        case ADD_RSS_SELECT_THIRD_PARTIES_SHOW_SPINNER:
            return Object.assign(
                {}, state, {
                    loadingSpinner: state.loadingSpinner + 1
                }
            );

        case ADD_RSS_SELECT_THIRD_PARTIES_HIDE_SPINNER:
            return Object.assign(
                {}, state, {
                    loadingSpinner: state.loadingSpinner > 0 ? state.loadingSpinner - 1 : 0
                }
            );

        case ADD_RSS_COUNT_THIRD_PARTIES:
            return Object.assign(
                {}, state, {
                    totalCount: action.payload
                }
            );

        case ADD_RSS_FILTER_COUNT_THIRD_PARTIES:
            return Object.assign(
                {}, state, {
                    filterCount: action.payload
                }
            );


        case ADD_RSS_CLEAR_SELECTED_THIRD_PARTIES:
            return Object.assign(
                {}, state, {
                    selectedThirdParties: []
                }
            );

        case ADD_RSS_SELECT_THIRD_PARTIES:
            return Object.assign(
                {}, state, {
                    selectedThirdParties: [...state.selectedThirdParties, ...action.payload]
                }
            );

        case ADD_RSS_DESELECT_THIRD_PARTY:
        {
            let deselectedItem = action.payload;

            if (deselectedItem !== -1) {
                return Object.assign(
                    {}, state, {
                        selectedThirdParties: [
                            ...state.selectedThirdParties.slice(0, deselectedItem),
                            ...state.selectedThirdParties.slice(deselectedItem + 1)
                        ]
                    }
                );
            }
        }
            break;

        case ADD_RSS_SET_CATEGORIES:
            return Object.assign(
                {}, state, {
                    categoryNames: action.payload
                }
            );

        case ADD_RSS_SELECT_CATEGORY:
        {
            let categories = [...state.selectedCategories, action.payload];

            return Object.assign(
                {}, state, {
                    selectedCategories:    categories,
                    allCategoriesSelected: categories.length === Object.keys(state.categoryNames).length ? true : false
                }
            );
        }

        case ADD_RSS_SET_SELECTED_CATEGORIES:
        {
            return Object.assign(
                {}, state, {
                    selectedCategories:    action.payload
                }
            );
        }

        case ADD_RSS_SET_SELECTED_THIRDPARTIES:
        {
            return Object.assign(
                {}, state, {
                    selectedThirdParties:    action.payload
                }
            );
        }

        case ADD_RSS_DESELECT_CATEGORY:
        {
            return Object.assign(
                {}, state, {
                    selectedCategories:    [
                        ...state.selectedCategories.slice(0, action.payload),
                        ...state.selectedCategories.slice(action.payload + 1)
                    ],
                    allCategoriesSelected: false
                }
            );
        }

        case ADD_RSS_SELECT_ALL_CATEGORIES:
        {
            return Object.assign({}, state, {
                selectedCategories:    [...Object.keys(state.categoryNames)],
                allCategoriesSelected: true
            });
        }

        case ADD_RSS_DESELECT_ALL_CATEGORIES:
        {
            return Object.assign({}, state, {
                selectedCategories:    [],
                allCategoriesSelected: false
            });
        }

        case ADD_RSS_TABLE_URL_CHANGE:
        {
            return Object.assign(
                {}, state, {
                    urlParams: Object.assign({}, state.urlParams, action.payload)
                }
            );
        }

        case ADD_RSS_SELECT_THIRD_PARTIES_SET: {
            let newArray = utils.mergeArraysByField('id', state.selectedThirdParties, action.payload);
            return Object.assign(
                {}, state, {
                    selectedThirdParties: newArray
                }
            );
        }

        case ADD_RSS_DESELECT_THIRD_PARTIES_SET: {
            let newArray = utils.subsetArrayByField('id', state.selectedThirdParties, action.payload);

            return Object.assign(
                {}, state, {
                    selectedThirdParties: newArray
                }
            );
        }


        default:
            return state;

    }

}

function feedInformation(state = null, action) {

    switch (action.type) {

        default:
            return state;

    }

}

function saveErrors(state = [], action) {

    switch (action.type) {

        case ADD_RSS_SAVE_ERROR:
        {
            if (state.indexOf(action.payload) === -1) {
                return [...state, action.payload]
            } else {
                return state;
            }
        }

        case ADD_RSS_CLEAR_SAVE_ERRORS:
        {

            if (utils.isArray(action.payload)) {
                return utils.arrayDiff(state, action.payload, true);
            }

            return [];
        }

        default:
            return state;

    }

}

function isFeedNameValid(state = false, action) {

    switch (action.type) {

        case ADD_RSS_FEED_NAME_VALIDATED:
            return true;

        case ADD_RSS_FEED_NAME_INVALIDATED:
            return false;

        default:
            return state;

    }

}

function riskAngles(state = null, action) {

    switch (action.type) {

        case ADD_RSS_CHANGE_RISK_ANGLES:
            return action.payload;

        default:
            return state;

    }

}

function addRssFeed(state, action) {

    switch (action.type) {
        case ADD_RSS_RESET_PAGE:
            return {
                isFeedNameValid: false,
                feedInformation: {
                    feedName: ''
                },
                thirdParties:    {
                    categoryNames:          {},
                    selectedCategories:     [],
                    selectedThirdParties:   [],
                    allCategoriesSelected:  false,
                    thirdPartySelectionBox: 'all-third-parties-section',
                    loadingSpinner:         false,
                    totalCount:       null,
                    filterCount:      null,
                    urlParams:              {
                        sortBy:           'companyTitleSort',
                        direction:        'asc',
                        categoryIdFilter: null,
                        refreshToggle:    0
                    }
                },
                riskAngles:      {
                    political:     3,
                    economic:      3,
                    social:        3,
                    technological: 3,
                    legal:         3,
                    environmental: 3
                },
                saveErrors:      []
            };

        case ADD_RSS_CHANGE_FEED_DATA:
            return action.payload;
    }

    const addRssFeedCombined = combineReducers({
        isFeedNameValid,
        feedInformation,
        thirdParties,
        riskAngles,
        saveErrors
    });

    return addRssFeedCombined(state, action);
}

export default addRssFeed;


// WEBPACK FOOTER //
// ./src/scripts/pages/RSSEditing/BaseFeedEditingComponent/BaseFeedEditingComponent.reducers.js